import { GET_ROUND_ID } from "./actionTypes";

export const getRoundID = (id) => {
  return {
    type: GET_ROUND_ID,
    payload: id,
  };
};
